<template>
  <v-container :fluid="true" class="bg-light-beige ma-0 pa-0" v-if="$route.name === names.SCIENCE_ID.PAGE">
    <div class="page__title">
      Создание учетной записи
    </div>
    <div v-if="science_id_data !== null && !loading">
      <div class="page__subtitle">
        Вы, {{ science_id_data.last_name + ' ' + science_id_data.name + ' ' + science_id_data.middle_name }}, выполнили вход используя Science-Id <br>
        Для продолжения работы в системе выполните регистрацию
      </div>
      <div class="text_field__container">
        <v-form
            ref="form"
            class="text_field__container"
        >
          <v-text-field
              class="text__field"
              color="#3254B9"
              base-color="#313743"
              variant="outlined"
              name="login"
              :readonly="true"
              v-model="science_id_data.email"
              :loading="loading"
              :error="hasError('email')"
              :error-messages="getError('email')"
          >
            <template v-slot:label>
              <div class="label__text">
                Электронная почта
              </div>
            </template>
          </v-text-field>
          <v-text-field
              id="password"
              v-model="data.password"
              :append-inner-icon="show ? 'visibility_off' : 'visibility'"
              :type="show ? 'text' : 'password'"
              :title="passwordMsg"
              :rules="[rules.required, rules.passStr, rules.symbControl]"
              :loading="loading"
              @click:appendInner="show = !show"
              class="text__field"
              color="#3254B9"
              base-color="#313743"
              variant="outlined"
              :error="hasError('password')"
              :error-messages="getError('password')"
          >
            <template v-slot:label>
              <div class="label__text">
                Пароль
              </div>
            </template>
          </v-text-field>
          <v-text-field
              id="password"
              v-model="data.repeat"
              :append-inner-icon="approve_show ? 'visibility_off' : 'visibility'"
              :type="approve_show ? 'text' : 'password'"
              :rules="[rules.repeatPass]"
              :loading="loading"
              @click:appendInner="approve_show = !approve_show"
              @keyup.enter="validate"
              class="text__field"
              color="#3254B9"
              base-color="#313743"
              variant="outlined"
              :error="hasError('repeat')"
              :error-messages="getError('repeat')"
          >
            <template v-slot:label>
              <div class="label__text">
                Подтверждение пароля
              </div>
            </template>
          </v-text-field>
        </v-form>
        <!--      <div class="text__field text-black">-->
        <!--        <v-alert-->
        <!--            class="error_alert"-->
        <!--            v-if="error"-->
        <!--            :value="true"-->
        <!--            rounded="lg"-->
        <!--            outline-->
        <!--            color="#8f0808"-->
        <!--            icon=""-->
        <!--            variant="outlined"-->
        <!--        >-->
        <!--          {{ error.error }}-->
        <!--        </v-alert>-->
        <!--      </div>-->
        <div v-if="error_reg" class="btn__next" @click="$router.push({name: names.MAIN})">
          <span class="btn__next_text">
            На главную
          </span>
        </div>
        <v-btn
            v-else
            class="btn__next"
            elevation="0"
            :loading="loading"
            @click="validate"
        >
          <span class="btn__next_text">
            Отправить
          </span>
        </v-btn>
      </div>
    </div>
    <div v-else-if="science_id_data === null && !loading">
      <div class="page__subtitle">
        У Вас уже есть аккаунт, выполните авторизацию <br>
        Скоро вы будете перенаправлены
      </div>
    </div>
    <div v-else>
      <v-row no-gutters justify="center" align="center" style="height: 25vh; min-height: 200px">
        <fulfilling-square-spinner
            :animation-duration="4000"
            :size="100"
            color="#34347C"
        />
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import names from "@/modules/core/routers/names"
import pa_names from "@/modules/personal_account/routers/names"
import { mapActions, mapGetters } from "vuex"
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import { set_stores } from "@/store/modules/auth"
import { FulfillingSquareSpinner } from "epic-spinners"

export default defineComponent({
  name: "AuthFromAnother",
  mixins: [FormErrorsMixin],
  components: { FulfillingSquareSpinner },
  data () {
    return {
      loading: false,
      valid: false,
      show: false,
      approve_show: false,
      error: null,
      error_reg: false,
      science_id_data: null,
      data: {
        password: null,
        repeat: null
      },
      passwordMsg: "Пароль должен иметь размер не менее 8 символов, содержать латинские буквы нижнего, верхнего регистров, а так же цифру. Может содержать только символы от a до Z, цифры от 0 до 9",
      rules: {
        required: value => !!value || 'Введите пароль',
        symbControl: value => this.symbControl(value) || 'Некорректный ввод',
        passStr: value => {
          const pattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!#$%&'*+\-.:<=>?@^_`|~]{8,}$/
          return pattern.test(value) || this.passwordMsg
        },
        repeatPass: value => {
          if (value !== null) {
            return this.data.password === value || 'Пароли не совпадают'
          } else {
            return 'Подтвердите ввод пароля'
          }
        },
      }
    }
  },
  watch: {
    data: {
      handler: function () {
        this.errors = {
          fields: {},
          non: []
        }
      },
      deep: true
    }
  },
  computed: {
    pa_names () {
      return pa_names
    },
    names () {
      return names
    },
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
    })
  },
  methods: {
    set_stores: set_stores,
    ...mapActions({
      getScienceId: 'personal_account/science_id/getScienceId',
      postScienceId: 'personal_account/science_id/postScienceId',
      searchScienceId: 'personal_account/science_id/searchScienceId',
    }),
    endRedirect () {
      this.$router.push({ name: names.REGISTRATION.PAGE })
    },
    async validate () {
      const { valid } = await this.$refs.form.validate()

      if (valid) {
        this.postScienceIdData()
      }
    },
    getScienceIdData: function (id) {
      this.loading = true
      this.error = null
      this.getScienceId(
        {
          science_id: id,
          finalizer: (data) => {
            this.loading = false
            this.error = null
            this.science_id_data = data
            // this.endRedirect()
          },
          catcher: (error) => {
            this.loading = false
            this.mapErrors(error)
          }
        }
      )
    },
    postScienceIdData: function () {
      this.loading = true
      this.error = null
      this.postScienceId(
        {
          science_id: this.science_id_data.science_id,
          data: this.data,
          finalizer: (data) => {
            this.loading = false
            this.error = null
            this.set_stores(data.token, data.email, "")
            setTimeout(() => {
              this.endRedirect()
            }, 300)
          },
          catcher: (error) => {
            this.loading = false
            if (error.email[0] === "user с таким email уже существует.") {
              this.error_reg = true
              error.email[0] = "Пользователь с таким адресом электронной почты уже существует."
            }
            this.mapErrors(error)
          }
        }
      )
    },
    searchScienceIdData: function (id) {
      this.loading = true
      this.error = null
      this.searchScienceId(
        {
          data: {
            type: "Identifier",
            token: id
          },
          finalizer: (data) => {
            if (data.is_found && data.is_linked) {
              setTimeout(() => {
                this.endRedirect()
              }, 3000)
            } else if (data.is_found && !data.is_linked) {
              this.$router.push({ name: names.SCIENCE_ID.BIND, query: { token: id, type: 'Identifier' } })
            } else {
              this.getScienceIdData(this.$route.query.science_id)
            }
            this.loading = false
            this.error = null
          },
          catcher: () => {
            this.loading = false
            this.error_reg = true
          }
        }
      )
    },
    symbControl: function (value) {
      if (value === null) {
        return true
      }
      return !(value.includes(' ') || value.includes('\n'))
    }
  },
  created () {
    if (this.$route.query.science_id && !this.isAuthenticated) {
      this.searchScienceIdData(this.$route.query.science_id)
    } else {
      this.$router.push({ name: names.MAIN })
    }
  },
})
</script>

<style scoped lang="scss">
.page__title {
  margin-top: 30px;
  margin-bottom: 30px;
  font-style: normal;
  font-weight: 800;
  font-size: 75px;
  line-height: 84px;
  text-align: center;

  color: #3254B9;
}

.page__subtitle {
  margin-bottom: 50px;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 51px;
  text-align: center;

  color: #313743;
}

.text_field__container {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 500px;
}

.text__field {
  margin: 0 auto 20px;
  width: 100%;
}

.v-field__field:hover {
  .label__text {
    color: black;
  }
}

.label__text {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  text-align: center;

  color: #313743;
}

.btn__next {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: end;
  margin-bottom: 40px;
  width: 220px;
  height: 80px;
  border: 2px solid #3254B9;
  background-color: #3254B9;
  border-radius: 10px;

  &.back {
    margin-right: 50px;
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }

    &:hover {
      background-color: #3254B9;

      .btn__next_text {
        color: #FFFFFF;
      }
    }
  }

  &:hover {
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }
  }
}

.btn__next_text {
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #FFFFFF;
}

.error_alert {
  border-radius: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: #8f0808;
  margin-bottom: 20px;
}

@media screen and (max-width: 1920px) {
  .page__title {
    font-size: 65px;
    line-height: 74px;
  }

  .page__subtitle {
    margin-bottom: 40px;
    font-size: 30px;
    line-height: 41px;
  }

  .text__field {
    margin-bottom: 10px;
  }

  .btn__next {
    height: 70px;
  }
}

@media screen and (max-width: 1279px) {
  .page__title {
    font-size: 50px;
    line-height: 57px;
    padding: 0 40px;
  }

  .page__subtitle {
    font-size: 24px;
    line-height: 31px;
    padding: 0 40px;
  }
}

@media screen and (max-width: 768px) {
  .page__title {
    font-size: 30px;
    line-height: 37px;
    padding: 0 20px;
  }

  .page__subtitle {
    margin-bottom: 40px;
    font-size: 18px;
    line-height: 22px;
    padding: 0 20px;
  }

  .text_field__container {
    width: 400px;
  }

  .label__text {
    font-size: 16px;
    line-height: 20px;
  }

  .btn__next {
    margin: 0 10px 20px;
    height: 55px;

    &.back {
      margin-right: 10px;
    }
  }

  .btn__next_text {
    font-size: 16px;
    line-height: 20px;
  }
}

@media screen and (max-width: 600px) {
  .text_field__container {
    width: 270px;
  }

  .text__field {
    margin-bottom: 8px;
  }
}
</style>
